import React from 'react';
import { filteredRestaurantsSelector } from '@arreeba/ristoranti-frontend-lib/lib/selectors/booking';

import Url from '../../lib/url';
import { connect } from '../../util';
import RestaurantRow from '../../components/restaurant-row';
import List from '../../components/list';

const BookingStart = (props) => {
  return (
    <main>
      <p>Scegli il ristorante presso il quale vuoi prenotare il tuo tavolo.</p>
      <List>
        {props.filteredRestaurants.map(r => {
          return (
            <RestaurantRow
              restaurant={r}
              href={Url.booking(props.params.appId)}
              key={r.id}
              availability={r.availableForBooking}
            />
          );
        })}
      </List>
    </main>
  )
};


const connectOptions = {
  mapStateToProps: (state, props) => ({
    ...state,
    filteredRestaurants: filteredRestaurantsSelector(state, props),
  }),
};


export default connect(BookingStart, connectOptions);



// WEBPACK FOOTER //
// ./src/containers/booking/booking-start.js